import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ExchangeFixedPriceComponent } from './exchange-fixed-price.component';

@NgModule({
  declarations: [
    ExchangeFixedPriceComponent
  ],
  imports: [
    CommonModule,
    MatSlideToggleModule
  ], exports: [
    ExchangeFixedPriceComponent
  ]
})
export class ExchangeFixedPriceModule { }
